// [claude] MCP marketing page tokens. The page renders inside ScreenWrapper, so the
// Ink dark theme (utility/theme.js) arrives via its ThemeProvider and supplies every
// token this page uses except the three below. Merged on top by McpMarketing.jsx.
// `green` stays page-local on purpose: Ink's `success` (#8BC16A) is the muted status
// green, not the bright connected-state green this page reads with.
// Last updated: 2026-07-16

export const mcpTheme = parent => ({
  ...parent,
  borderHover: parent.borderStrong,
  green: '#1BCD6D',
  greenDim: 'rgba(27, 205, 109, 0.1)',
});
